var render = function () {
  var _vm$item, _vm$item2, _vm$item$types, _vm$item3, _vm$item4;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-list-group', {
    attrs: {
      "append-icon": 'mdi-menu-down',
      "color": _vm.item.categoryColor || 'primary',
      "value": _vm.expanded,
      "no-action": ""
    },
    on: {
      "input": function ($event) {
        return _vm.$emit('input');
      }
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function () {
        return [_c('v-list-item-avatar', {
          staticClass: "item-avatar ma-0"
        }, [_c('v-avatar', {
          staticClass: "font-weight-bold white--text",
          attrs: {
            "color": _vm.item.categoryColor || 'black'
          }
        }, [_vm._v(_vm._s(_vm.item.dayOfWeek) + " "), _c('br'), _vm._v(_vm._s(_vm.item.dateHuman))])], 1), _c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "text-subtitle-1 font-weight-black primary--text pb-1"
        }, [_vm._v(_vm._s(_vm.item.title) + " "), _vm.item.registration_enabled ? _c('v-tooltip', {
          attrs: {
            "color": "primary",
            "open-on-hover": "",
            "top": ""
          },
          scopedSlots: _vm._u([{
            key: "activator",
            fn: function (_ref) {
              var on = _ref.on,
                  attrs = _ref.attrs;
              return [_c('v-icon', _vm._g(_vm._b({
                attrs: {
                  "color": "warning",
                  "x-small": ""
                }
              }, 'v-icon', attrs, false), on), [_vm._v("mdi-file-sign")])];
            }
          }], null, false, 1159665319)
        }, [_c('div', {
          staticClass: "d-flex flex-column align-start"
        }, [_c('span', {
          staticClass: "font-weight-bold"
        }, [_vm._v("Requires Registration")]), _c('span', {
          staticClass: "text-caption"
        }, [_vm._v(_vm._s(_vm.item.registrationWindow))])])]) : _vm._e()], 1), _c('v-list-item-title', {
          staticClass: "text-body-2 primary--text",
          domProps: {
            "textContent": _vm._s(_vm.item.dateTimeHuman)
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('v-card', {
    attrs: {
      "color": "transparent"
    }
  }, [_c('v-card-text', {
    staticClass: "details-text d-flex flex-column align-start justify-start"
  }, [_vm.item.registrationWindow ? [_c('p', {
    staticClass: "detail-name text-body-2 warning--text font-weight-bold"
  }, [_vm._v("Registration: " + _vm._s(_vm.item.registrationWindow || ' -'))])] : _vm._e(), _c('p', {
    staticClass: "mt-2 mb-4",
    staticStyle: {
      "max-width": "120ch"
    },
    domProps: {
      "innerHTML": _vm._s(((_vm$item = _vm.item) === null || _vm$item === void 0 ? void 0 : _vm$item.program_description) || ((_vm$item2 = _vm.item) === null || _vm$item2 === void 0 ? void 0 : _vm$item2.description) || 'Please call for more information.')
    }
  }), (_vm$item$types = _vm.item.types) !== null && _vm$item$types !== void 0 && _vm$item$types.length ? _c('v-sheet', {
    staticClass: "mb-2"
  }, _vm._l(_vm.item.types, function (type) {
    return _c('v-chip', {
      key: type.id,
      staticClass: "font-weight-bold mr-1",
      attrs: {
        "color": "primary",
        "small": ""
      }
    }, [_vm._v(_vm._s(type.text))]);
  }), 1) : _vm._e(), _c('v-sheet', {
    staticClass: "d-flex flex-row flex-lg-column align-end align-lg-start justify-space-between flex-wrap",
    attrs: {
      "width": "100%"
    }
  }, [_c('v-sheet', {
    staticClass: "flex-grow-1 mr-2"
  }, [_c('p', [_c('span', {
    staticClass: "detail-name text-body-1 font-weight-bold"
  }, [_vm._v("Date:")]), _vm._v(" " + _vm._s(_vm.item.dateHuman || ' -') + " ")]), _c('p', [_c('span', {
    staticClass: "detail-name text-body-1 font-weight-bold"
  }, [_vm._v("Time:")]), _vm._v(" " + _vm._s(_vm.item.timeStartHuman) + " - " + _vm._s(_vm.item.timeEndHuman) + " ")]), _c('p', [_c('span', {
    staticClass: "detail-name text-body-1 font-weight-bold"
  }, [_vm._v("Instructor:")]), _vm._v(" " + _vm._s(_vm.item.instructor || ' -') + " ")]), _c('p', [_c('span', {
    staticClass: "detail-name text-body-1 font-weight-bold"
  }, [_vm._v("Location:")]), _vm._v(" " + _vm._s(_vm.item.location || ' -') + " ")])]), _c('v-sheet', {
    staticClass: "pt-2"
  }, [_c('v-btn', {
    staticClass: "mt-2",
    attrs: {
      "color": "primary",
      "href": _vm.item.url,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "small": ""
    }
  }, [_vm._v(_vm._s(("mdi-" + ((_vm$item3 = _vm.item) !== null && _vm$item3 !== void 0 && _vm$item3.registration_enabled ? 'file-sign' : 'open-in-new'))))]), _vm._v(" " + _vm._s((_vm$item4 = _vm.item) !== null && _vm$item4 !== void 0 && _vm$item4.registration_enabled ? 'REGISTER / VIEW' : 'FULL DETAILS') + " ")], 1)], 1)], 1)], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }